import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ScheduleAConsultation from "./sections/ScheduleAConsultation";
import OurServiceArea from "./sections/OurServiceArea";
import SiteReadyFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ScheduleAConsultation />
      <OurServiceArea />
      <SiteReadyFooter />
    </div>;
}